import React, { useEffect } from "react";
import { Box, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import classes from "./newsList.module.scss";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { getNewsList } from "redux-api/slices/newsSlice";
import { REQUEST_STATUSES } from "common/constants";

const MAX_LENGTH = 65;

const NewsList = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { newsList, newsListStatus } = useSelector((state) => state.news);
  const { i18n } = useTranslation();
  const currentLang = i18n.language;

  const handleNavigate = (slug) => {
    if (!slug) return;
    navigate(`/news/${slug}`);
  };

  // Подгружаем новости при первом рендере
  useEffect(() => {
    if (newsListStatus === REQUEST_STATUSES.NOT_REQUESTED) {
      dispatch(getNewsList());
    }
  }, [dispatch, newsListStatus]);

  if (newsListStatus === REQUEST_STATUSES.LOADING) {
    return <Typography>Loading...</Typography>;
  }

  if (newsListStatus === REQUEST_STATUSES.FAILED) {
    return <Typography>Error loading news.</Typography>;
  }

  return (
    <Box className={classes.allColumn}>
      {newsListStatus === REQUEST_STATUSES.SUCCEEDED &&
        newsList?.results?.map((item) => {
          const title =
            item?.[`title_${currentLang}`] ||
            item?.title_ru ||
            item?.title ||
            "";

          return (
            <Box
              key={item.id}
              className={classes.card}
              onClick={() => handleNavigate(item.slug)}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => {
                if (e.key === "Enter") handleNavigate(item.slug);
              }}
            >
              <img
                className={classes.newsImages}
                alt={title}
                src={item?.news_images?.[0]?.image}
              />
              <Typography className={classes.description}>
                {title.length > MAX_LENGTH
                  ? title.slice(0, MAX_LENGTH) + "..."
                  : title}
              </Typography>
            </Box>
          );
        })}
    </Box>
  );
};

export default NewsList;
